import React, { useEffect, useState } from "react";
import { ref, get } from "firebase/database";
import { db } from "../../firebase";
import "./CounselingHome.css";
import { useNavigate } from "react-router-dom";
import {
  Dialog,
  DialogContent,
  IconButton,
  Box
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useRef } from "react";
export default function CounselingHome() {

  const navigate = useNavigate();
  const scrollRefs = useRef({});
  const [efc, setEfc] = useState([]);
  const [counselling, setCounselling] = useState([]);
  const [lectures, setLectures] = useState([]);

  // ================= VIDEO MODAL =================
  const [videoOpen, setVideoOpen] = useState(false);
const [videoUrl, setVideoUrl] = useState("");

  // ================= PREMIUM =================
  const [premium, setPremium] = useState(false);
  const [showPremium, setShowPremium] = useState(false);

  const [now, setNow] = useState(Date.now());
useEffect(() => {

  const intervals = [];

  Object.keys(scrollRefs.current).forEach(key => {

    const container = scrollRefs.current[key];
    if (!container) return;

    let interval;

    const startAutoScroll = () => {
      interval = setInterval(() => {

        const maxScrollLeft =
          container.scrollWidth - container.clientWidth;

        if (container.scrollLeft >= maxScrollLeft - 5) {
          container.scrollTo({ left: 0, behavior: "smooth" });
        } else {
          container.scrollBy({
            left: container.clientWidth * 0.8,
            behavior: "smooth"
          });
        }

      }, 3000);
    };

    const stopAutoScroll = () => {
      clearInterval(interval);
    };

    // Pause on hover
    container.addEventListener("mouseenter", stopAutoScroll);
    container.addEventListener("mouseleave", startAutoScroll);

    // Pause while touching (mobile)
    container.addEventListener("touchstart", stopAutoScroll);
    container.addEventListener("touchend", startAutoScroll);

    startAutoScroll();

    intervals.push(interval);
  });

  return () => {
    intervals.forEach(i => clearInterval(i));
  };

}, []);
useEffect(() => {
  const timer = setInterval(() => {
    setNow(Date.now());
  }, 1000);

  return () => clearInterval(timer);
}, []);
  // ================= OPEN / CLOSE INFO =================

const openInfo = (url) => {
  if (!url) return;
  setVideoUrl(url);
  setVideoOpen(true);
};

const closeInfo = () => {
  setVideoOpen(false);
  setVideoUrl("");
};


  // ================= PREMIUM CHECK =================

  useEffect(() => {

    const uid = localStorage.getItem("uid");

    if (!uid) {
      setPremium(false);
      return;
    }

    const fetchPremium = async () => {
      try {
        const snap = await get(ref(db, "users/" + uid));

        if (snap.exists()) {
          setPremium(snap.val().is_premium === true);
        }

      } catch (err) {
        console.log("Premium fetch error", err);
      }
    };

    fetchPremium();

  }, []);


  // ================= THUMBNAIL =================

  const getThumbnail = (videoUrl, thumbUrl) => {

    if (thumbUrl && thumbUrl.includes("drive.google.com")) {

      let fileId = "";

      const match1 = thumbUrl.match(/\/d\/([a-zA-Z0-9_-]+)/);
      const match2 = thumbUrl.match(/[?&]id=([a-zA-Z0-9_-]+)/);

      if (match1) fileId = match1[1];
      else if (match2) fileId = match2[1];

      if (fileId) {
        return `https://lh3.googleusercontent.com/d/${fileId}`;
      }
    }

    if (thumbUrl) return thumbUrl;

    if (videoUrl?.includes("youtube") || videoUrl?.includes("youtu.be")) {

      let id = "";

      if (videoUrl.includes("watch?v="))
        id = videoUrl.split("watch?v=")[1].split("&")[0];
      else if (videoUrl.includes("youtu.be/"))
        id = videoUrl.split("youtu.be/")[1];

      if (id) {
        return `https://img.youtube.com/vi/${id}/hqdefault.jpg`;
      }
    }

    return "";
  };


  // ================= FIREBASE =================

useEffect(() => {
  const fetchVideos = async () => {
    try {
      const videoRef = ref(db, "videos");
      const snapshot = await get(videoRef);

      if (!snapshot.exists()) return;

      const data = snapshot.val();

      // ---------- EFC ----------
// ---------- EFC (ONLY FIRST VIDEO OF EACH SUBJECT) ----------

let efcVideos = [];

if (data.efc) {

  Object.keys(data.efc).forEach(subject => {

    const subjectVideos = data.efc[subject];
    const firstKey = Object.keys(subjectVideos || {})[0];

    if (!firstKey) return;

    const v = subjectVideos[firstKey];

    efcVideos.push({
      id: subject, // use subject as id
      title: subject, // show subject name instead of video title
      videoUrl: null, // we won’t open direct video
      thumbnailUrl: getThumbnail(
        v.videoUrl || v.vimeoUrl,
        v.thumbnailUrl
      ),
      subject: subject, // important
      status: "normal"
    });

  });

}
      // ---------- FLAT MAPPER ----------
      const mapFlat = (obj) => {
  if (!obj) return [];

  return Object.keys(obj).map(id => {
    const v = obj[id];

    const startTime = v.liveStartTime
      ? new Date(v.liveStartTime).getTime()
      : null;

    let status = "normal";

    if (startTime) {
      const endTime = startTime + (3 * 60 * 60 * 1000); // 3 hours

      if (now < startTime) {
        status = "upcoming";
      } else if (now >= startTime && now <= endTime) {
        status = "live";
      }
    }

    return {
      id,
      title: v.title || "No Title",
      videoUrl: v.videoUrl || v.vimeoUrl,
      thumbnailUrl: getThumbnail(
        v.videoUrl || v.vimeoUrl,
        v.thumbnailUrl
      ),
      liveStartTime: startTime,
      status
    };
  });
};


      const counsellingVideos = mapFlat(data.counselling);
      const lectureVideos = mapFlat(data.lectures);

      // ---------- COMBINE ----------
      const allVideos = [
        ...efcVideos,
        ...counsellingVideos,
        ...lectureVideos
      ];

      const liveVideos = allVideos.filter(v => v.status === "live");
      const upcomingVideos = allVideos.filter(v => v.status === "upcoming");

      // ---------- SET STATES ----------
      setEfc(efcVideos);
      setCounselling(counsellingVideos);

const sortedLectures = [...lectureVideos].sort((a, b) => {

  // 1️⃣ LIVE first
  if (a.status === "live" && b.status !== "live") return -1;
  if (b.status === "live" && a.status !== "live") return 1;

  // 2️⃣ Upcoming next
  if (a.status === "upcoming" && b.status === "normal") return -1;
  if (b.status === "upcoming" && a.status === "normal") return 1;

  // 3️⃣ Latest startTime first
  return (b.liveStartTime || 0) - (a.liveStartTime || 0);
});

setLectures(sortedLectures.slice(0, 5));

      // ---------- PRELOAD THUMBNAILS ----------
      allVideos.forEach((video, index) => {

  if (!video.thumbnailUrl) return;

  // preload only first 10 instantly
  if (index < 10) {
    const img = new Image();
    img.src = video.thumbnailUrl;
  }

  // delay remaining thumbnails
  else {
    setTimeout(() => {
      const img = new Image();
      img.src = video.thumbnailUrl;
    }, 200 * index);
  }

});

    } catch (error) {
      console.log("Error fetching videos:", error);
    }
  };

  fetchVideos();
}, []);


  // ================= OPEN VIDEO =================

  const openVideo = (url) => {

    if (!premium) {
      setShowPremium(true);
      return;
    }

    if (!url) return;

    if (url.includes("youtube") || url.includes("youtu.be")) {
      window.open(url, "_blank");
      return;
    }

    navigate("/player", {
      state: { url }
    });
  };


  // ================= ROW =================

const renderRow = (list, keyName) => {
  return (
    <div
      className="scroll-row"
      ref={(el) => (scrollRefs.current[keyName] = el)}
    >
      {list.map(video => (
        <VideoCard
          key={video.id}
          video={video}
          openVideo={openVideo}
          navigate={navigate}
        />
      ))}
    </div>
  );
};
  // ================= BUY =================

  const handleBuyPremium = () => {
    setShowPremium(false);
    navigate("/counselling-program");
  };


  return (

    <div className="page">

      {/* ===== HEADER ===== */}

      <div className="learninghub-header">

        <h1 className="learninghub-title">

          Learning Hub

          <IconButton
  className="learninghub-info-btn"
  title="Watch Tutorial"
  onClick={() =>
    openInfo("https://player.vimeo.com/video/1166283892?badge=0&autopause=0")
  }
>
  <InfoOutlinedIcon />
</IconButton>

        </h1>

      </div>


      {/* ===== SECTIONS ===== */}

      <Section
  title="Engineering Foundation Course"
  data={efc}
  renderRow={(data) => renderRow(data, "efc")}
  route="/efc-subjects"
  navigate={navigate}
/>

<Section
  title="Admission Counselling"
  data={counselling}
  renderRow={(data) => renderRow(data, "counselling")}
  route="/admission-videos"
  navigate={navigate}
/>

<Section
  title="Live Lectures"
  data={lectures}
  renderRow={(data) => renderRow(data, "lectures")}
  route="/live-videos"
  navigate={navigate}
/>
    <Dialog
  open={videoOpen}
  onClose={closeInfo}
  maxWidth="md"
  fullWidth
>
  <DialogContent dividers sx={{ p: 0 }}>
    <Box
      sx={{
        position: "relative",
        width: "100%",
        paddingTop: "56.25%",
        backgroundColor: "#000"
      }}
    >
      <IconButton
        onClick={closeInfo}
        sx={{
          position: "absolute",
          top: 8,
          right: 8,
          color: "#fff",
          zIndex: 10
        }}
      >
        <CloseIcon />
      </IconButton>

      <iframe
        src={videoUrl}
        title="Tutorial Video"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%"
        }}
        frameBorder="0"
        allow="autoplay; fullscreen"
        allowFullScreen
      />
    </Box>
  </DialogContent>
</Dialog>

      


      {/* ================= PREMIUM ================= */}

      {showPremium && (

        <div className="modal-backdrop">

          <div className="modal">

            <h3>Premium Access Required</h3>

            <p>Enroll for Counselling Program to access this content.</p>

            <div className="modal-actions">

              <button onClick={handleBuyPremium}>
                Enroll Now
              </button>

              <button onClick={() => setShowPremium(false)}>
                Cancel
              </button>

            </div>

          </div>

        </div>
      )}

    </div>
  );
}


/* ================= VIDEO CARD ================= */

function VideoCard({ video, openVideo, navigate }) {

  const [showImage, setShowImage] = useState(true);

  return (
    
    <div
      className="video-card"
      onClick={() => {
  if (video.subject) {
    navigate(`/efc-videos/${encodeURIComponent(video.subject)}`);
  } else {
    openVideo(video.videoUrl);
  }
}}
    >

<div className="thumb-box">

  {video.status === "live" && (
    <div className="live-badge">
      <span className="live-dot"></span>
      LIVE NOW
    </div>
  )}

{video.status === "upcoming" && (
  <div className="upcoming-badge">
    Going live at{" "}
    {video.liveStartTime
      ? new Date(video.liveStartTime).toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit"
        })
      : ""}
  </div>
)}
        {showImage && video.thumbnailUrl ? (

          <img
  src={video.thumbnailUrl}
  alt=""
  loading="lazy"
  decoding="async"
  onError={() => setShowImage(false)}
/>

        ) : (

          <div className="text-thumb">
            {video.title}
          </div>

        )}

      </div>

      <div className="video-title">
        {video.title}
      </div>
      
    </div>
  );
}


/* ================= SECTION ================= */

function Section({ title, data, renderRow, route, navigate }) {

  return (

    <div className="section">

      <div className="section-header">

        <h3>{title}</h3>

        <button
          className="show-btn"
          onClick={() => navigate(route)}
        >
          Show All
        </button>

      </div>

      {renderRow(data)}

    </div>
  );
}
